import React from 'react';
import { trackEvent } from '../utils/analytics';
import { ANALYTICS_EVENTS } from '../utils/analyticsEvents';
import affiliates from '../data/affiliates.json';

const REFERRAL_LINK = /n26\.com\/r\/|referral\.lemfi\.com|referral\.masterschool\.com|wise\.com\/invite/i;

// Adds rel="sponsored" to referral links that are written inside WordPress post content.
export const markSponsoredLinks = (html = '') => html.replace(/<a\s([^>]*?)>/gi, (tag, attrs) => {
  const href = attrs.match(/href="([^"]*)"/i);
  if (!href || !REFERRAL_LINK.test(href[1])) return tag;
  return `<a ${attrs.replace(/\s*rel="[^"]*"/i, '')} rel="sponsored noopener noreferrer">`;
});

const partnersFor = (slug) => (affiliates.posts[slug] || []).map((id) => ({ id, ...affiliates.partners[id] }));

// Shown at the top of any post that carries referral links (disclosure must come before the links).
export function AffiliateNotice({ slug }) {
  if (!partnersFor(slug).length) return null;
  return (
    <p className="mb-6 border-l-4 border-[#c9c5bf] bg-[#f5f4f2] px-4 py-3 text-sm text-[#5f5b56]">
      <strong>Werbung / Advertisement:</strong> this guide contains referral links. If you sign up through them,
      I may receive a reward at no extra cost to you. See our <a href="/privacy" className="underline">privacy policy</a>.
    </p>
  );
}

export function AffiliateBox({ slug }) {
  const partners = partnersFor(slug);
  if (!partners.length) return null;
  return (
    <div className="mt-8 grid gap-4">
      {partners.map((p) => (
        <div key={p.id} className="border border-stone-200 bg-[#f5f4f2] p-6">
          <p className="text-xs uppercase tracking-[0.25em] text-[#7b7671]">Werbung · Referral link</p>
          <h3 className="font-display text-2xl text-[#2d2b29] mt-3">{p.title}</h3>
          <p className="text-[#6a6661] mt-3">{p.text}</p>
          <a
            href={p.url}
            target="_blank"
            rel="sponsored noopener noreferrer"
            onClick={() => trackEvent(ANALYTICS_EVENTS.PARTNER_CLICK, { partner: p.id, location: 'post_box' })}
            className="inline-flex items-center justify-center mt-5 px-6 py-3 border border-[#c9c5bf] text-xs uppercase tracking-[0.25em] text-[#2d2b29] hover:bg-[#e7e4df] transition-colors"
          >
            Go to {p.name}
          </a>
        </div>
      ))}
    </div>
  );
}
